export default __webpack_public_path__ + "static/media/BusinessConsultingLebenswerkBusinessManagement1.07179b93.png";